export * from './BannerSlider.types'
export { default as WorkDetail } from './BannerSlider'
